import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function ConfirmActionDialogWatchlist(props) {
  const [open, setOpen] = React.useState(props.open);
  const [posName, setPosName] = React.useState(props.name);
  
  const handleClose = () => {
   
    props.cancelHandler();
  };

  const handleSave = (val) => {
   
      props.saveHandler(val);
  };

 
  return (
    <div>
     
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{whiteSpace:'pre-line'}}>
            {props.description}
          </DialogContentText>
          
        </DialogContent>
        <DialogActions>
        
          <Button    sx={{
      backgroundColor: '#163569',
      color: 'white',
      '&:hover': {
        backgroundColor: '#1565c0',
      },
    }}onClick={()=>handleSave(false)}>Continue without saving</Button>
      <Button   sx={{
      backgroundColor: '#1976d2',
      color: 'white',
      '&:hover': {
        backgroundColor: '#1565c0',
      },
    }} onClick={()=>handleSave(true)}>Save & Continue</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
